import "./PreviousSearchTerms.scss";

const PreviousSearchTerms = ({ handlePreviousSearchTerm, previousSearchTerms }) => {
  return (
    <>
      {previousSearchTerms && previousSearchTerms.length > 0 && (
        <div className="previous-search-terms__container">
          <div className="previous-search-terms__heading">Previous Searches</div>
          <ul className="previous-search-terms__list">
            {previousSearchTerms.map((term) => (
              <li
                key={term}
                className="previous-search-terms__list-option"
                role="option"
                tabIndex="0"
                onMouseDown={() => {
                  // This fires before onBlur on input, so no race condition
                  handlePreviousSearchTerm(term);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handlePreviousSearchTerm(term);
                  }
                }}
              >
                <span>{term}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default PreviousSearchTerms;
